module.exports = __webpack_public_path__ + "img/Whiplash_thumb.bbb3c38c.jpg";